import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import { relationCopy, sourceNote } from 'features/taskLinks/linkCopy'
import { ACCENT_SOFT, LINK, MUTED, BORDER } from 'features/actions/workspace/ui'

const LinkBadge = ({ relation, source }) => {
  const copy = relationCopy(relation)
  const note = sourceNote(source)
  const help = `${copy.help}${note ? ` ${note}. You can unlink it if it is wrong.` : ''}`
  return (
    <Tooltip title={help} placement='top' arrow>
      <Badge tabIndex={0} aria-label={`${copy.label}${note ? `, ${note.toLowerCase()}` : ''}. ${help}`} $handles={relation === 'handles'}>
        {copy.label}
        {note && <Auto>{note}</Auto>}
      </Badge>
    </Tooltip>
  )
}

export default LinkBadge

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  white-space: nowrap;
  cursor: help;
  color: ${({ $handles }) => ($handles ? LINK : MUTED)};
  background: ${({ $handles }) => ($handles ? ACCENT_SOFT : '#fff')};
  border: 1px solid ${({ $handles }) => ($handles ? '#b8e8ee' : BORDER)};
  &:focus-visible { outline: 2px solid ${LINK}; outline-offset: 2px; }
`

const Auto = styled.span`
  font-weight: 600;
  color: ${MUTED};
`
